import { render, staticRenderFns } from "./HouseCard.vue?vue&type=template&id=3e6d62ce&scoped=true&"
import script from "./HouseCard.vue?vue&type=script&lang=js&"
export * from "./HouseCard.vue?vue&type=script&lang=js&"
import style0 from "./HouseCard.vue?vue&type=style&index=0&id=3e6d62ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d62ce",
  null
  
)

export default component.exports